import { render, staticRenderFns } from "./PurchaseOrderDetails.vue?vue&type=template&id=1839e2fc&lang=pug&"
import script from "./PurchaseOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports